import {Utils} from "./Utils";
import rxmask from 'rxmask';

export interface FormValidatorConfig {
    form: HTMLElement;
    name: HTMLInputElement;
    phone: HTMLInputElement;
    agreement: HTMLInputElement;
    email?: HTMLInputElement;
}

type FormErrorList = {
    nameEmpty: string;
    nameShort: string;
    nameLong: string;
    phoneEmpty: string;
    phoneInvalid: string;
    emailEmpty: string;
    emailInvalid: string;
    disagree: string;
}

export class FormValidator {
    private readonly elements: {
        form: HTMLElement;
        name: HTMLInputElement;
        phone: HTMLInputElement;
        agreement: HTMLInputElement;
        email: HTMLInputElement;
    };
    public mask: rxmask;

    constructor({form, name, phone, agreement, email = undefined}: FormValidatorConfig) {
        this.elements = {form, name, phone, agreement, email};
        this.init();
    }

    public checkValue(element: HTMLInputElement) {
        return element ? !element.value : false;
    }

    public checkPhone(element: HTMLInputElement) {
        console.log(this.mask.parsedValue);
        return element ? !this.mask.parsedValue : false;
    }

    public getErrorList(): FormErrorList {
        if (Utils.getLang() === `ru_ru`) {
            return {
                nameEmpty: 'Имя должно быть заполнено',
                nameShort: 'Имя должно быть длиннее 1 символа',
                nameLong: 'Имя не должно быть длиннее 30 символов',
                phoneEmpty: 'Номер телефона должен быть заполнен',
                phoneInvalid: 'Номер телефона должен состоять из 10 цифр',
                emailEmpty: 'Поле e-mail обязательно к заполнению',
                emailInvalid: 'Введен некорректный email',
                disagree: 'Чтобы продолжить, необходимо принять условия'
            };
        } else {
            return {
                nameEmpty: 'You should enter a name',
                nameShort: 'Name must be longer than 1 characters',
                nameLong: 'Name must not be longer than 30 characters',
                phoneEmpty: 'You should enter a phone number',
                phoneInvalid: 'Phone number must consist of 10 digits',
                emailEmpty: 'E-mail field is required',
                emailInvalid: 'Invalid email address entered',
                disagree: 'You should accept the terms to continue'
            };
        }
    }

    public throwError(element: HTMLElement, text: string): boolean {
        if (element) {
            element.insertAdjacentHTML('afterend', `<span class="feedback__error">${text}</span>`);
            element.classList.add(`error`);
            return true;
        }
    }

    protected setPhoneMask(): void {
        if (!this.elements.phone) return;
        const
            code = this.elements.phone.getAttribute(`data-code`),
            parser = new rxmask({
                mask: `+${code} (___) ___-__-__`,
                placeholderSymbol: `_`,
                allowedCharacters: `[0-9]`,
                maxMaskLength: `Infinity`,
                trailing: `true`
            }, this.elements.phone);

        this.elements.phone.oninput = () => parser.onInput();
        this.mask = parser;
    }

    public validate(): boolean {
        const
            error = document.querySelectorAll(`.feedback__error`),
            errorList = this.getErrorList(),
            {phone, name, email} = this.elements;
        let
            errPhone = this.checkPhone(phone),
            errName = this.checkValue(name),
            errEmail = this.checkValue(email),
            errAgree = false;

        if (error.length) {
            error.forEach((it) => {
                it.parentNode.removeChild(it);
            });
        }

        errName = this.validateName(errName, errorList);
        errPhone = this.validatePhone(errPhone, errorList);
        errAgree = this.validateAgreement(errorList);

        if (email) {
            errEmail = this.validateEmail(errEmail, errorList);
            return ( errName || errEmail || errPhone || errAgree );
        }
        return ( errName || errPhone || errAgree );
    }

    public validateName(errName: boolean, errorList: FormErrorList): boolean {
        const {name} = this.elements;
        if (errName) return this.throwError(name, errorList.nameEmpty);
        if (name.value.length < 2) return this.throwError(name, errorList.nameShort);
        if (name.value.length > 30) return this.throwError(name, errorList.nameLong);
        name.classList.remove(`error`);
    }

    public validatePhone(errPhone: boolean, errorList: FormErrorList): boolean {
        const {phone} = this.elements;
        if (errPhone) return this.throwError(phone, errorList.phoneEmpty);
        if (+this.mask.parsedValue.length !== 10) return this.throwError(phone, errorList.phoneInvalid);
        phone.classList.remove(`error`);
    }

    public validateEmail(errEmail: boolean, errorList: FormErrorList): boolean {
        const
            {email} = this.elements,
            reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;

        if (errEmail) return this.throwError(email, errorList.emailEmpty);
        if (!reg.test(email.value)) return this.throwError(email, errorList.emailInvalid);
        email.classList.remove(`error`);
    }

    public validateAgreement(errorList: FormErrorList): boolean {
        const
            {agreement} = this.elements,
            agreementContainer = agreement.parentNode as HTMLElement;

        if (!agreement.checked) return this.throwError(agreementContainer, errorList.disagree);
        agreementContainer.classList.remove(`error`);
    }

    protected init(): void {
        if (this.elements.form) {
            this.setPhoneMask();
            this.elements.form.addEventListener('submit', (evt) => {
                if (this.validate()) evt.preventDefault();
            });
        }
    }
}